import { groupErrorsByTarget } from '@wix/form-validator';
import React, { useCallback, useMemo } from 'react';
import { FieldPropsContext } from '../../../../contexts/field-props-context';
import { useForm } from '../../../../contexts/form-context';
import { useExternalData } from '../../contexts/external-data-context';
import { useFormFields } from '../../contexts/form-fields-context';
export const NestedFormField = ({ field, errors, values, onFieldChange, FieldLayout })=>{
    const componentsById = useFormFields();
    const externalData = useExternalData();
    const form = useForm();
    const fieldValue = values[field.target];
    const errorsByTarget = useMemo(()=>groupErrorsByTarget(errors), [
        errors
    ]);
    const fieldErrors = errorsByTarget?.[field.target];
    const fieldError = fieldErrors?.[0];
    const { requiredIndicator, requiredIndicatorPlacement } = form.requiredIndicatorProperties || {};
    const handleChange = useCallback((value)=>{
        if (!value) {
            value = null;
        }
        onFieldChange?.(field.target, value);
    }, [
        onFieldChange,
        field
    ]);
    const FieldComponent = componentsById[field.fieldType];
    if (!FieldComponent) {
        return null;
    }
    const fieldProps = {
        ...field.properties,
        onChange: handleChange,
        error: fieldError,
        errors: fieldErrors,
        value: fieldValue,
        id: field.id,
        target: field.target,
        path: field.path,
        externalData,
        fieldType: field.fieldType,
        FieldLayout,
        requiredIndicatorType: requiredIndicator,
        requiredIndicatorPlacement
    };
    return /*#__PURE__*/ React.createElement(FieldPropsContext.Provider, {
        value: {
            v2: fieldProps
        }
    }, /*#__PURE__*/ React.createElement(FieldComponent, fieldProps));
};

//# sourceMappingURL=nested-form-field.js.map